import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend/public/assets/2025_Falcon_Trophy_4k.png");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend/public/assets/hero-hd.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["Ceremony"] */ "/var/www/joy-awards-frontend/src/app/[lang]/about/components/ceremony.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/app/[lang]/about/components/html-content-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/app/[lang]/about/components/video.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend/src/components/shared/image/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend/src/components/ui/animations/fade.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend/src/components/ui/animations/reveal.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend/src/components/ui/animations/zoom.tsx");
